<template>
<div class="chapter">
<div class="inner_page">
<h2 class="author">17</h2>
<p class="vers"><span>Ich warte</span> nur auf die
Liebe, um<br class="calibre1"/>
endlich mich in seine Hände aufzugeben.<br class="calibre1"/>
Deshalb bin ich so spät, und deshalb bin<br class="calibre1"/>
ich schuldig so vieler Lücken.</p>
<p class="vers">Sie kommen mit ihren Gesetzen und<br class="calibre1"/>
Regeln, um mich zu binden, doch ich<br class="calibre1"/>
entschlüpfe ihnen immer wieder, denn<br class="calibre1"/>
ich warte nur auf die Liebe, um endlich<br class="calibre1"/>
mich in seine Hände aufzugeben.</p>
<p class="vers">Die Leute tadeln mich, nennen mich<br class="calibre1"/>
unbedacht, ich zweifle nicht, sie haben<br class="calibre1"/>
Recht zum Tadel.</p>
<p class="vers">Der Markttag ist vorüber, alle Arbeit<br class="calibre1"/>
ist getan für die Geschäftigen. Die da kamen<br class="calibre1"/>
umsonst mich zu rufen, gingen voll<br class="calibre1"/>
Zorn. Ich aber warte nur auf die Liebe,<br class="calibre1"/>
um endlich mich in seine Hände aufzugeben. <a id="page22" title="cal/wedi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0018.vue?3954bbd0